import { render, staticRenderFns } from "./MydtmNews.vue?vue&type=template&id=23f59463&scoped=true&"
import script from "./MydtmNews.vue?vue&type=script&lang=js&"
export * from "./MydtmNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f59463",
  null
  
)

export default component.exports